import { useEffect, useState } from "react";
import Constants from "../Constants";
import ModelRenderer from "./ModelRenderer";

const MaterialModel = (props) => {

    const glbModels = {
        'Fabric' : './models/Sofa.glb',
        'Hard Surface' : './models/Table.glb'
    };

    const [type, setType] = useState('');
    const [materialInfoJson, setMaterialInfoJson] = useState({})

    useEffect(() => {
        fetch(Constants.BASE_URL_MATERIALS + props.id + '/material_info.json')
        .then(response => response.text())
        .then(text => {
            let json = JSON.parse(text)
            setMaterialInfoJson(json)
            if ( json['type'] != undefined ) {
                setType(json['type'])
            }
        })
        .catch(err => console.error(err));
    },[])

    // Don't render until we have valid data
    if (!type || !materialInfoJson.maps || !glbModels[type]) {
        return null;
    }

    return (
        <ModelRenderer 
            glb={glbModels[type]} 
            materialInfoJson={materialInfoJson} 
            id={props.id} 
            fabricType={type}
        />
    );
};

export default MaterialModel;